import { API } from 'aws-amplify';
import {
  REACT_APP_BASE_KEY,
  REACT_APP_BASE_NAME,
  REACT_APP_CLIENT_NAME,
} from '../config/settings/environments';

/**
 * To get the times.
 */
export const getTimes = async ({ year, month, day, turno }) => {
  const paths = {
    talabre: '/v1/get-times',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-times';
  if (year && month && day && turno) {
    path = `${path}?year=${year}&month=${month}&day=${day}&turno=${turno}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get the group times.
 */
export const getTimesGroup = async ({ start_date, end_date }) => {
  const paths = {
    talabre: '/v1/get-times-group',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-times-group';
  if (start_date && end_date) {
    path = `${path}?start_date=${start_date}&end_date=${end_date}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};